import React from 'react';
import { Button as ButtonMui } from '@mui/material';
import styles from './Modal.module.scss';

export const Title: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div
      data-cy={'modal-title'}
      className={styles.title}
    >
      {label}
    </div>
  );
};

export const Button: React.FC<{ onClick: () => void; label: string; disabled: boolean }> = ({
  onClick,
  label,
  disabled,
}) => {
  return (
    <ButtonMui
      data-cy={'modal-action'}
      onClick={onClick}
      className={styles.button}
      disabled={disabled}
    >
      {label}
    </ButtonMui>
  );
};
